import { Box } from '@mui/material';
import {
  enableLayerFor,
  selectVisibilityMapFor,
  setDefaultVisibilityMapFor,
} from '../../../../../reducers/canvasLayersReducer';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { useConfigurationCanvasContext } from '../../ConfigurationCanvasContext';
import { useRunOnceWhenTruthy } from '../../../../common/useRunOnceWhenTruthy';
import useQueryParams from '../../../../../navigation-utils/useQueryParams';
import { VisibilityElementLayersSelector } from '../../types';
import { VisibilityLayers } from '../../../../../types/enums/VisibilityLayers';
import { useForwardPinchToSweepCanvas } from '../../../../sweep-canvas/hooks/useForwardPinchToSweepCanvas';
import LayersSelector from './LayersSelector';

export const ConfigurationCanvasLayersSelector = ({
  visibilityElements,
}: {
  visibilityElements: VisibilityElementLayersSelector;
}) => {
  const { layersId, defaultVisibilityMap } = visibilityElements;
  const dispatch = useDispatch();
  const visibilityMap = useSelector(selectVisibilityMapFor(layersId));
  const { setCommentsOn } = useConfigurationCanvasContext();

  const query = useQueryParams();
  const commentId = query.get('comment');

  useEffect(() => {
    dispatch(setDefaultVisibilityMapFor({ layersId, visibilityMap: defaultVisibilityMap || {} }));
  }, [defaultVisibilityMap, dispatch, layersId]);

  useEffect(() => {
    if (!visibilityMap[VisibilityLayers.COMMENTS]) {
      setCommentsOn(false);
    }
  }, [visibilityMap, dispatch, setCommentsOn, layersId]);

  useRunOnceWhenTruthy(() => {
    dispatch(
      enableLayerFor({
        layer: VisibilityLayers.COMMENTS,
        layersId: layersId,
      }),
    );
  }, Boolean(commentId));

  const [divRef, setDivRef] = useState<HTMLDivElement | null>(null);

  useForwardPinchToSweepCanvas({ element: divRef });

  return (
    <Box
      sx={{
        zIndex: 100,
        position: 'absolute',
        left: 16,
        bottom: 16,
        display: 'flex',
        gap: 1,
        alignItems: 'center',
      }}
      ref={setDivRef}
    >
      <LayersSelector
        visibilityMap={visibilityMap}
        position="bottom-right"
        layersId={layersId}
        buttonVariant="system"
      />
    </Box>
  );
};
